import { render, staticRenderFns } from "./add-widget-modal.vue?vue&type=template&id=8ba9424e"
import script from "./add-widget-modal.vue?vue&type=script&lang=js"
export * from "./add-widget-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports